import ontarioCanadaMap from './ontario-canada-map.svg';

export default {
  ontarioCanadaMap,
};
